// extracted by mini-css-extract-plugin
module.exports = {"ButtonsPanel":"ButtonsPanel_ButtonsPanel__1Tuf7"};